export default __webpack_public_path__ + "static/dosis-3e75d17d4a70c42bf129516719cea24c.ttf";